import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { SezioneEconomica } from 'src/app/common/models/sezioni/sezione-economica';
import { TipoOpposizione } from 'src/app/common/models/tipologiche/tipo-opposizione';
import { ModalNotifyService } from 'src/app/core/services/modal-notify.service';
import { DatiGeneraliConFondoRischiForm } from "../../../common/form/dati-generali-con-fondo-rischi-form";
import { AutoritaGiudiziaria } from "../../../common/models/tipologiche/autorita-giudiziaria";
import { Comune } from "../../../common/models/tipologiche/comune";
import { Grado } from "../../../common/models/tipologiche/grado";
import { TipoNatura } from "../../../common/models/tipologiche/tipo-natura";
import { FormValidationService } from "../../../common/services/form-validation.service";
import { HelpersService } from "../../../core/services/helpers.service";
import { OperationsService } from "../../../core/services/operations.service";
import { OperationsUrlSettingsFascicolo } from '../../fascicoloGeneric/configuration/operations-url-settings-fascicolo';
import { MetadataExt } from 'src/app/common/models/metadati/metadata';
import { ProtocolMetadata } from 'src/app/common/protocol/models/protocol';

@Component({
  selector: 'app-form-opposizione-decreto-ingiuntivo',
  templateUrl: './form-opposizione-decreto-ingiuntivo.component.html',
  styleUrls: ['./form-opposizione-decreto-ingiuntivo.component.css']
})
export class FormOpposizioneDecretoIngiuntivoComponent extends DatiGeneraliConFondoRischiForm implements OnInit, OnChanges {

  datiGeneraliForm: FormGroup;
  tipiNatura: TipoNatura[] = [];
  gradi: Grado[] = [];
  autoritaGiudiziarie: AutoritaGiudiziaria[] = [];
  cittaPerAutoritaGiudiziaria: Comune[] = [];
  idPratica: string;
  tipoFascicolo: string;
  tipoPratica: number;
  tipiOpposizione: TipoOpposizione[]=[];
  gradoSubscription: Subscription;
  genericFascicolo: string;
  idFascicolo: string;
  gradoFascicolo: any;
  sezioneEconomicaFascicolo: SezioneEconomica;
  metadataFormValid: boolean = false;
  protocollo: ProtocolMetadata;

  @Input() fascicolo;
  @Input() request;
  @Input() nomeFascicolo;
  @Input() labelCreatoDaSistema;
  @Input() minervaWizard = false;
  @Output() saveForm = new EventEmitter();
  @Output() resetForm = new EventEmitter();
  @Output() createForm = new EventEmitter();

  constructor(protected operationService: OperationsService,
              private formValidationService: FormValidationService,
              private campiForm: FormBuilder,
              private helpers: HelpersService,
              private modalNotifyService: ModalNotifyService,
              private activatedRoute: ActivatedRoute) {
    super();
    activatedRoute.params.subscribe( params => {
      this.genericFascicolo = params.genericFascicolo;
      this.idFascicolo = params.idFascicolo;
    });
  }

  ngOnInit() {
    this.createFascicoloForm(true);
    this.populateSelect();
    this.inizializzaFondoRischi(this.request.fascicolo.flagFondoRischi, this.request.fascicolo.dataVariazioneFondoRischi);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.request && changes.request.currentValue) {
      this.createFascicoloForm();
    }
  }

  createFascicoloForm(init = false) {
    this.datiGeneraliForm = this.campiForm.group({
      natura: [init ? null : this.request.fascicolo.natura, Validators.required],
      tipoVisibilita: [init ? null : this.request.fascicolo.tipoVisibilita],
      dataInizioFascicolo: [init ? null : this.request.fascicolo.dataInizioFascicolo, Validators.required],
      dataDefinizione: [init ? null : this.request.fascicolo.dataDefinizione],
      stato: [init ? null : this.request.fascicolo.stato],
      motivoDefinizione: [init ? null : this.request.fascicolo.motivoDefinizione],
      flagProcessoTelematico: [init ? null : this.request.fascicolo.flagProcessoTelematico],
      definito: [init ? null : this.request.fascicolo.definito],
      flagFondoRischi: [init ? null : this.request.fascicolo.flagFondoRischi],
      recuperoCrediti: [init ? false : this.request.fascicolo.recuperoCrediti],
      //dataVariazioneFondoRischi: [init ? null : this.request.fascicolo.dataVariazioneFondoRischi],
      nruolo: [init ? null : this.request.fascicolo.numeroRuolo],
      annoRuolo: [init ? null : this.request.fascicolo.annoRuolo, Validators.compose([this.formValidationService.anno])],
      giudice: [init ? null : this.request.fascicolo.giudice],
      sezione: [init ? null : this.request.fascicolo.sezione],
      autoritaGiudiziaria: [init ? null : this.request.fascicolo.autoritaGiudiziaria, Validators.required],
      autoritaGiudiziariaCitta: [init ? null : this.request.fascicolo.autoritaGiudiziariaCitta, Validators.required],
      grado: [init ? null : this.request.fascicolo.grado],
      motivoOpposizione: [init ? null : this.request.fascicolo.motivoOpposizione],
      numRuoloDecretoRif: [init ? null : this.request.fascicolo.numRuoloDecretoRif],
      posizioneFascicoloRif: [init ? null : this.request.fascicolo.posizioneFascicoloRif],
      dataInizioFascicoloRif: [init ? null : this.request.fascicolo.dataInizioFascicoloRif],
      valoreFascicoloRif: [init ? null : this.request.fascicolo.valoreFascicoloRif],
      tipoOpposizione: [init ? null: this.request.fascicolo.tipoOpposizione],
      note: [init ? null : this.request.fascicolo.note],
      metadata: [init ? null : this.request.fascicolo.metadata],
      descrizioneOggetto: [init ? null : this.request.fascicolo.descrizioneOggetto, Validators.required],
      dataPrimaComparizione:[init ? null : this.request.fascicolo.dataPrimaComparizione],
      dataDepositoRicorso: [init ? null : this.request.fascicolo.dataDepositoRicorso],
      flagCostituzione:[init ? true : this.request.fascicolo.flagCostituzione],
      motivazione: [init ? null : this.request.fascicolo.motivazione],      
      dataCostituzione: [init ? null : this.request.fascicolo.dataCostituzione],
      
    });
    if(!this.inserimento && !this.minervaWizard){
      this.gradoFascicolo = {...this.request.fascicolo.grado};
      this.readSezioneEconomica();
    }
    if(this.minervaWizard){
      this.createForm.emit();
    }
    this.readProtocollo()
  }


  populateSelect() {
    if (this.gradi.length === 0) {
      this.helpers.getGradi().subscribe(response => this.gradi = response);
    }
    if (this.autoritaGiudiziarie.length === 0) {
      this.helpers.getAutoritaGiudiziarie().subscribe(response => this.autoritaGiudiziarie = response);
    }

    if (this.request.fascicolo && this.request.fascicolo.autoritaGiudiziaria && this.request.fascicolo.autoritaGiudiziaria.id) {
      this.helpers.getCittaPerAutoritaGiudiziaria(this.request.fascicolo.autoritaGiudiziaria.id).subscribe(response => this.cittaPerAutoritaGiudiziaria = response);
  }
  if(this.tipiOpposizione.length===0){
    this.helpers.getTipiOpposizione().subscribe(response=>this.tipiOpposizione=response);
  }
  }

  loadCittaPerAutoritaGiudiziaria(event: any) {
    this.cittaPerAutoritaGiudiziaria = [];
    this.request.fascicolo.autoritaGiudiziariaCitta = undefined;
    let idAutorita = event.target.value;
    if (idAutorita !== '-1') {
      this.helpers.getCittaPerAutoritaGiudiziaria(idAutorita).subscribe(response => this.cittaPerAutoritaGiudiziaria = response);
    }
  }

  readSezioneEconomica(){
    this.operationService.readFascicolo(OperationsUrlSettingsFascicolo.URL_GET_FASCICOLO(this.genericFascicolo), this.request.fascicolo.id).subscribe(response=>{
      if(response.fascicolo.idSezioneDatiEconomici && !this.sezioneEconomicaFascicolo){
        this.operationService.readSezione(OperationsUrlSettingsFascicolo.URL_GET_SEZIONE_ECONOMICA(this.genericFascicolo), response.fascicolo.idSezioneDatiEconomici).subscribe(response=>{
          this.sezioneEconomicaFascicolo = response.sezione;
        });
      }
    });
  }

  changedGrado(): boolean {
    return this.request.fascicolo.grado ? (this.gradoFascicolo.id && this.request.fascicolo.grado.id!==this.gradoFascicolo.id) : !!(this.gradoFascicolo.id)
  }

  checkContributoUnificato(): boolean {
    if(!this.sezioneEconomicaFascicolo){
      this.readSezioneEconomica();
    }
    return (this.changedGrado() && this.sezioneEconomicaFascicolo && !!this.sezioneEconomicaFascicolo.contributoUnificato);
  }

  isFormMetadataValid(value: boolean){
    this.metadataFormValid = value;
  }

  onRetrieve(value : MetadataExt[]){
    this.request.fascicolo.metadata = value.map(value => value);
  }
  onDataProtocol(value: ProtocolMetadata) {
    if (value) {
      this.request.fascicolo.numeroFascicoloProtocollo = value.dossierNumber;
      this.request.fascicolo.numeroProtocollo = value.protocolNumber;
      this.request.fascicolo.dataProtocollazione = value.protocolTimestamp;
      this.request.fascicolo.oggettoProtocollo = value.subject;
      this.request.fascicolo.senderReceiver = value.senderReceiver;
      this.request.fascicolo.utenteProtocollatore = value.protocolUser;
      this.request.fascicolo.inUscita = value.tipoReg.toLowerCase() === "in uscita";
      this.request.fascicolo.protocolDocuments = value.protocolDocuments.map(d => (d.documentRef));
    } else {
      this.request.fascicolo.numeroFascicoloProtocollo = null;
      this.request.fascicolo.numeroProtocollo = null;
      this.request.fascicolo.dataProtocollazione = null;
      this.request.fascicolo.oggettoProtocollo = null;
      this.request.fascicolo.senderReceiver = null;
      this.request.fascicolo.utenteProtocollatore = null;
      this.request.fascicolo.inUscita = null;
      this.request.fascicolo.protocolDocuments = null;
    }
  }
  readProtocollo() {
    if(this.fascicolo.numeroProtocollo){
      this.protocollo={
      dossierNumber: this.fascicolo.numeroFascicoloProtocollo,
      protocolNumber: this.fascicolo.numeroProtocollo,
      protocolTimestamp: this.fascicolo.dataProtocollazione,
      subject: this.fascicolo.oggettoProtocollo,
      senderReceiver:this.fascicolo.senderReceiver,
      protocolUser: this.fascicolo.utenteProtocollatore,
      tipoReg: this.fascicolo.inUscita ? "IN USCITA" : "IN ENTRATA"
    }}
  }
  save() {
    if(!this.inserimento && !this.minervaWizard && !!this.checkContributoUnificato()){
      this.gradoSubscription = this.modalNotifyService.notifyConfirmObservable.subscribe(result =>{
        if(!!result){
          this.saveForm.emit();
        } else{
          this.gradoSubscription.unsubscribe();
        }
      });
      this.modalNotifyService.notifyCustom('Confermando il cambio del tipo di grado di rischio, verrà annullato il valore inserito nel contributo unificato. Continuare?');
    } else{
      this.saveForm.emit();
    }
  }
}
